<template>
  <v-card class="elevation-0">
    <v-card-title>
      <span class="headline" v-if="showHeader">Approvers</span>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" label="Search Here"></v-text-field>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :items="items"
        :headers="headers"
        :search="search"
        :footer-props="footerProps"
        :loading="loading"
      >
        <template v-slot:item.actions="{item}">
          <slot name="actions" v-bind:item="item"></slot>
        </template>
        <template v-slot:item.active="{item}">
          <!-- <slot name="actions" v-bind:item="item"></slot> -->
          <!-- <v-checkbox :input-value="item.active" value readonly></v-checkbox> -->
          <v-icon :color="item.active ? 'success' : 'grey'" dark>mdi-circle</v-icon>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
const API_ENDPOINT = "/api/approverMember";
export default {
  props: {
    showHeader: {
      default: false,
      type: Boolean
    },
    groupCode: {
      default: "",
      type: String
    }
  },
  data: () => ({
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Approver",
        value: "fullName",
        sortable: true
      },
      {
        text: "Order",
        value: "approverOrder",
        sortable: true
      },
      {
        text: "Active",
        value: "active",
        sortable: true
      },
      {
        text: "Remarks",
        value: "remarks",
        sortable: true
      }
    ],
    loading: false,
    search: "",
    footerProps: {
      rowsPerPageItems: [20, 50]
    }
  }),
  methods: {
    // getAll() {
    //   this.loading = true;
    //   this.$axios
    //     .get(`${API_ENDPOINT}`)
    //     .then(({ data }) => {
    //       this.items = data;
    //     })
    //     .catch(({ response }) => {
    //       this.$toast.error(response.data.message);
    //     })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },
    getAll(groupCode) {
      this.loading = true;
      this.$axios
        .get(`${API_ENDPOINT}/${groupCode}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    if (this.groupCode !== "") this.getAll(this.groupCode);
  },
  mounted() {}
};
</script>
<style scoped>
.inactive {
  background-color: rebeccapurple;
}
</style>